declare var angular: any;
import * as _ from 'underscore';
import * as moment from 'moment';
import { Answers } from '../../../../../../../libs/models/src';
import { flattenDeep, uniq } from 'lodash';

import { getLanguage } from '../../../../translations/pure';

import {
  calculateMeanOfTheObject,
  calculatePartsLevelsDelf,
  getAverageByPartsDelf,
  getSectionsByLevel
} from '../../../../app/delf/estimate';

declare var Rollbar: any;
declare var Pusher: any;

angular
  .module('GlobalControllers')

  .service('localData', [
    '$http',
    function($http) {
      this.get = function(url) {
        return $http.get(url, { cache: 'true' }).then(function(response) {
          return response.data;
        });
      };
    }
  ])

  .service('lang', [
    '$translate',
    'translateService',
    function($translate, translateService) {
      this.availables = [
        {
          label: 'Français',
          value: 'fr'
        },
        {
          label: 'English',
          value: 'en'
        }
      ];
      this.key = getLanguage();

      this.changeLanguage = (langKey: string) => {
        console.log('langKey', langKey);
        $translate.use(langKey);
        translateService.use(langKey);
        this.key = langKey;
        window.localStorage.setItem('lang', langKey);
      };
    }
  ])

  .service('api', [
    'API_URL',
    'EXAM',
    'ENVIRONMENT',
    '$http',
    '$mdToast',
    '$q',
    'exam',
    '$window',
    '$location',
    '$translate',
    function(
      API_URL,
      EXAM,
      ENVIRONMENT,
      $http,
      $mdToast,
      $q,
      exam,
      $window,
      $location,
      $translate
    ) {
      // EXAM = 'bright';

      var self = this;
      self.data = localStorage.getItem('api') || '{}';
      self.data = JSON.parse(self.data);
      console.log(self.data);

      self.sync = function(api_call, callback, id) {
        if (typeof callback === 'function') {
          if (self.data[api_call.dataName]) {
            if (typeof id !== 'undefined' && self.data[api_call.dataName][id]) {
              callback(self.data[api_call.dataName][id]);
            } else if (typeof id === 'undefined') {
              callback(self.data[api_call.dataName]);
            }
          }
        }
        return api_call(id).then(
          function(data) {
            if (callback) callback(data);
            localStorage.setItem('api', JSON.stringify(self.data));
          },
          function(error) {
            if (error.status < 0) {
              if (
                !(typeof id === 'undefined' && self.data[api_call.dataName]) &&
                !(
                  typeof id !== 'undefined' &&
                  self.data[api_call.dataName] &&
                  self.data[api_call.dataName][id]
                )
              ) {
                // cache failed
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      $translate.instant(['toasts.offline'])['toasts.offline']
                    )
                    .position('bottom right')
                );
              }
            } else {
              return $q.reject(error);
            }
          }
        );
      };

      self.login = function(username, password) {
        return $http
          .post(API_URL + '/login' + '?exam=' + EXAM, {
            username: username,
            password: password
          })
          .then(function(response) {
            self.data.token = response.data.token;
            localStorage.setItem('api', JSON.stringify(self.data));
          });
      };

      // Should be at the top because of the cache
      exam.setLevel(self.data?.me?.profile?.level);

      /*
    birth_year
    first_name
    is_student
    last_name
    offers
    password
    username
    */
      self.register = function(data) {
        var fData = _.omit(data, 'password2');
        fData.email = data.username;
        return $http
          .post(API_URL + '/register' + '?exam=' + EXAM, fData)
          .then(function(response) {
            self.data.token = response.data.token;
            localStorage.setItem('api', JSON.stringify(self.data));
          });
      };

      self.activateBook = function(code) {
        return $http
          .post(
            API_URL + '/activate',
            { exam: EXAM, code: code },
            { headers: { 'X-Auth-Token': self.data.token } }
          )
          .then(function() {
            self.me();
          });
      };

      self.facebookAuth = function(access_token) {
        return $http
          .post(API_URL + '/facebook/auth' + '?exam=' + EXAM, {
            access_token: access_token
          })
          .then(function(response) {
            self.data.token = response.data.token;
            localStorage.setItem('api', JSON.stringify(self.data));
          });
      };

      self.microsoftAuth = function(access_token) {
        return $http
          .post(API_URL + '/microsoft/auth' + '?exam=' + EXAM, {
            access_token: access_token
          })
          .then(function(response) {
            self.data.token = response.data.token;
            localStorage.setItem('api', JSON.stringify(self.data));
          });
      };

      self.googleAuth = function(access_token) {
        return $http
          .post(API_URL + '/google/auth' + '?exam=' + EXAM, {
            access_token: access_token
          })
          .then(function(response) {
            self.data.token = response.data.token;
            localStorage.setItem('api', JSON.stringify(self.data));
          });
      };

      self.logout = function() {
        console.log('logout');
        return $http
          .post(
            API_URL + '/logout',
            {},
            { headers: { 'X-Auth-Token': self.data.token } }
          )
          .then(function(response) {
            self.data.token = null;
            self.data.me = null;
            localStorage.setItem('api', JSON.stringify(self.data));
            delete $window.localStorage.dateOfRegister;
            $location.url('/');
          })
          .catch(err => {
            self.data.token = null;
            self.data.me = null;
            localStorage.setItem('api', JSON.stringify(self.data));
            delete $window.localStorage.dateOfRegister;
            $location.url('/');
          });
      };

      let alreadySentDataToThirdParties = false;
      self.me = function() {
        var config = self.data.token
          ? { headers: { 'X-Auth-Token': self.data.token } }
          : {};
        return $http
          .get(API_URL + '/me?exam=' + EXAM, config)
          .then(function(response) {
            var id = null;
            var username = null;
            var email = null;
            var expiration_date = null;
            var institution_id = null;

            if (
              response.data &&
              response.data &&
              response.data.user &&
              response.data.profile
            ) {
              if (response.data.profile.id) {
                id = response.data.profile.id;
              }
              if (response.data.user.username) {
                username = response.data.user.username;
              }
              if (response.data.user.email) {
                email = response.data.user.email;
              }
              if (response.data.profile.expiration_date) {
                expiration_date = response.data.profile.expiration_date;
              }
              if (response.data.institution && response.data.institution.id) {
                institution_id = response.data.institution.id;
              }
            }
            // check if we are in prod mod
            if ((window as any).Rollbar) {
              Rollbar.configure({
                payload: {
                  person: {
                    id: id, // required
                    username: username,
                    email: email,
                    exam_type: EXAM
                  }
                }
              });
            }

            if (
              !alreadySentDataToThirdParties &&
              (window as any).fbq &&
              institution_id
            ) {
              (window as any).fbq('trackCustom', 'HasInstitution');
              alreadySentDataToThirdParties = true;
            }

            if ((window as any).Intercom) {
              (window as any).Intercom('update', {
                user_id: id
              });
            }
            self.data.me = response.data;
            return response.data;
          })
          .then(res => {
            exam.setLevel(self.data.me.profile.level);

            return res;
          });
      };
      self.me.dataName = 'me';

      function getLessonsAnonymous() {
        var config = self.data.token
          ? { headers: { 'X-Auth-Token': self.data.token } }
          : {};
        return $http
          .get(API_URL + '/lessons?exam=' + EXAM, config)
          .then(function(response) {
            var sortLessons = _.sortBy(response.data, 'title');
            self.data.lessons = sortLessons;
            return sortLessons;
          });
      }

      self.getLesson = function(lessonId) {
        var config = self.data.token
          ? { headers: { 'X-Auth-Token': self.data.token } }
          : {};
        return $http
          .get(API_URL + '/lesson/' + lessonId + '?exam=' + EXAM, config)
          .then(function(response) {
            self.data.lesson = self.data.lesson || {};
            self.data.lesson[lessonId] = response.data;
            return response.data;
          });
      };
      self.getLesson.dataName = 'lesson';

      /*
    self.getStats = function () {
      return $http.get(API_URL + '/stats?exam=' + EXAM, {headers: {'X-Auth-Token': self.data.token}})
      .then(function (response) {
        self.data.stats = response.data;
        return response.data;
      });
    };
    self.getStats.dataName = 'stats';
    */

      self.changeObjective = function(objective) {
        return $http.post(
          API_URL + '/change_objective',
          { objective: objective, exam: EXAM },
          { headers: { 'X-Auth-Token': self.data.token } }
        );
      };

      self.changeEmail = function(email) {
        return $http.post(
          API_URL + '/change_email' + '?exam=' + EXAM,
          { email: email },
          { headers: { 'X-Auth-Token': self.data.token } }
        );
      };

      self.changePassword = function(old_password, new_password) {
        return $http.post(
          API_URL + '/password',
          {
            old_password: old_password,
            new_password: new_password
          },
          { headers: { 'X-Auth-Token': self.data.token } }
        );
      };

      self.saveAnswer = (
        choice: string,
        mock: boolean,
        extraValue: string,
        answerIdToUpdate: number = null
      ) => {
        return (answerIdToUpdate
          ? Promise.resolve({ data: { answer: { id: answerIdToUpdate } } })
          : $http.post(
              API_URL + '/answer',
              { choices: [parseInt(choice)], exam: EXAM, mock: mock },
              { headers: { 'X-Auth-Token': self.data.token } }
            )
        ).then(async res => {
          if (extraValue) {
            let answerId = res?.data?.answer?.id;
            let data = {
              extra_value: extraValue
            };
            if (answerId) {
              this.updateAnswersGQL(answerId, data);
            }
          }
          return res?.data;
        });
      };

      self.getSupport = function(supportId = null) {
        let url = API_URL + '/support?exam=' + EXAM + '&type=all';
        if (supportId) {
          url = `${url}&support_id=${supportId}`;
        }

        if (self.data.me.profile.level) {
          url = url + '&level=' + self.data.me.profile.level;
        }

        return $http
          .get(url, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            prefixSupportFiles(response.data.support);
            return response.data;
          });
      };

      self.getSupports = function(part, n, buildup) {
        let url =
          API_URL +
          '/supports?exam=' +
          EXAM +
          '&type=part-' +
          part +
          '&n=' +
          n +
          '&buildup=' +
          buildup;

        if (self.data.me.profile.level) {
          url = url + '&level=' + self.data.me.profile.level;
        }

        return $http
          .get(url, { headers: { 'X-Auth-Token': self.data.token } })
          .then(function(response) {
            response.data.supports.forEach(function(support) {
              prefixSupportFiles(support);
            });
            return response.data;
          });
      };

      self.getSupportByLesson = function(lessonId) {
        return $http
          .get(API_URL + '/support?exam=' + EXAM + '&type=lesson-' + lessonId, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            prefixSupportFiles(response.data.support);
            return response.data;
          });
      };

      self.getSupportByParts = function(partNumbers, buildup) {
        let url =
          API_URL +
          '/support?exam=' +
          EXAM +
          '&type=part-' +
          partNumbers.toString().replace(/,/g, '-') +
          (buildup ? '&buildup=true' : '');

        console.log('🔥yolo', self.data.me.profile.level);
        if (self.data.me.profile.level) {
          url = url + '&level=' + self.data.me.profile.level;
        }

        return $http
          .get(url, { headers: { 'X-Auth-Token': self.data.token } })
          .then(function(response) {
            prefixSupportFiles(response.data.support);
            return response.data;
          });
      };

      self.getPrices = function(promocode = null) {
        let url = API_URL + '/prices?exam=' + EXAM;

        if (promocode) {
          url = `${url}&discount_code=${promocode}`;
        }

        return $http.get(url).then(function(response) {
          return response.data;
        });
      };

      self.getPaymentToken = function() {
        return $http.get(API_URL + '/payment-token').then(function(response) {
          return response.data;
        });
      };

      self.checkout = function(
        nonce,
        days,
        firstName,
        lastName,
        address,
        postalCode,
        city,
        promocode
      ) {
        let url = API_URL + '/checkout?exam=' + EXAM;

        if (promocode) {
          url = `${url}&discount_code=${promocode}`;
        }

        return $http
          .post(
            url,
            {
              days: parseInt(days),
              exam: EXAM,
              nonce: nonce,
              first_name: firstName,
              last_name: lastName,
              address: address,
              postal_code: postalCode,
              city: city,
              discount_code: promocode
            },
            { headers: { 'X-Auth-Token': self.data.token } }
          )
          .then(function(response) {
            return response.data;
          });
      };

      self.getArticles = function() {
        return $http
          .get(
            'https://ghost.polylearn.co/ghost/api/v0.1/posts/?fields=id,slug,title,html,markdown,tags,image,url&include=tags&client_id=ghost-frontend&client_secret=e2c45bffb8e7&limit=50'
          )
          .then(function(response) {
            response.data.posts = _.map(response.data.posts, function(
              post: any
            ) {
              post.image = 'https://ghost.polylearn.co' + post.image;
              return post;
            });

            response.data.posts = _.filter(response.data.posts, function(
              post: any
            ) {
              return _.find(post.tags, function(tag: any) {
                return tag.name === EXAM.toUpperCase();
              });
            }).filter(posts => {
              let level = self.data?.me?.profile?.level;
              if (!level) {
                return true;
              }

              return posts?.tags?.find(tag => tag.name === level);
            });

            self.data.articles = response.data.posts;
            return response.data.posts;
          });
      };
      self.getArticles.dataName = 'articles';

      self.getWords = function() {
        return $http
          .get(API_URL + '/words', {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            self.data.words = response.data;
            return response.data;
          });
      };
      self.getWords.dataName = 'words';

      self.getWord = function(word) {
        return $http
          .get(API_URL + '/word?word=' + word)
          .then(function(response) {
            self.data.word = self.data.word || {};
            self.data.word[word] = response.data.word;
            return response.data.word;
          });
      };
      self.getWord.dataName = 'word';

      this.addWord = function(word) {
        return $http
          .post(
            API_URL + '/word',
            { word: word },
            { headers: { 'X-Auth-Token': self.data.token } }
          )
          .then(function(response) {
            self.data.words.push(response.data.word);
            return response.data.word;
          });
      };

      this.removeWord = function(word) {
        return $http({
          method: 'DELETE',
          url: API_URL + '/word',
          data: { word: word },
          headers: {
            'X-Auth-Token': self.data.token,
            'Content-Type': 'application/json;charset=utf-8'
          }
        }).then(function(response) {
          self.data.words.splice(self.data.words.indexOf(response.data), 1);
          return response.data;
        });
      };

      let InsertFeedbackGQL = `mutation InsertFeedbacks($obj: feedbacks_insert_input!) {
      insert_feedbacks(objects: [$obj]) {
        returning {
          id
        }
      }
    }
    `;

      this.insertFeedbacks = (supportId, supportCopy, information) => {
        let data = {
          obj: {
            userId: self.data.me.user.id,
            supportId,
            supportCopy,
            information
          }
        };
        return makeGraphQLRequest(
          'InsertFeedbacks',
          InsertFeedbackGQL,
          data,
          'user'
        ).then(function(response) {
          return response.data;
        });
      };

      var GetResultsGQL = `query GetResults($exam_type: exam_types!, $level: String, $userId: Int!) {
        results(where: {user_id: {_eq: $userId}, _and: {exam: {exam_type: {_eq: $exam_type}, level: {_eq: $level}}}}, order_by: {created_at: desc}) {
          created_at
          score
          oral_score
          writing_score
          reading_score
          listening_score
          id
        }
      }
      `;

      this.getResults = function() {
        var data = {
          userId: self.data.me.user.id,
          exam_type: EXAM,
          level: self.data.me.profile.level
        };
        return makeGraphQLRequest(
          'GetResults',
          GetResultsGQL,
          data,
          'user'
        ).then(function(response) {
          self.data.results = response.data.results;
          return response.data.results;
        });
      };
      this.getResults.dataName = 'results';

      this.getResult = function(id) {
        return $http
          .get(API_URL + '/result/' + id + '?exam=' + EXAM, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            self.data.result = self.data.result || {};
            self.data.result[id] = response.data;
            response.data.exam.supports.forEach(function(support) {
              prefixSupportFiles(support);
            });
            return response.data;
          });
      };
      this.getResult.dataName = 'result';

      this.getMock = function() {
        let url = API_URL + '/mock?exam=' + EXAM;

        if (self.data.me.profile.level) {
          url = url + '&level=' + self.data.me.profile.level;
        }

        return $http
          .get(url, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            self.data.me.profile.current_exam_id = response.data.exam.id;
            response.data.exam.supports.forEach(function(support) {
              prefixSupportFiles(support);
            });
            return response.data;
          });
      };
      this.getMock.dataName = 'mock';

      this.endMock = function() {
        return $http
          .post(
            API_URL + '/mock',
            { exam: EXAM },
            { headers: { 'X-Auth-Token': self.data.token } }
          )
          .then(function(response) {
            self.data.me.profile.current_exam_id = null;
            return response.data;
          });
      };

      /*
      this.getSpheres = function() {
        return $http
          .get(API_URL + '/spheres?exam=' + EXAM, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            self.data.spheres = response.data.spheres;
            return response.data.spheres;
          });
      };
      this.getSpheres.dataName = 'spheres';
      */

      this.addStudent = function(studentId, sphereId) {
        return $http.post(
          API_URL + '/manage/sphere/' + sphereId,
          { exam: EXAM, students_id: parseInt(studentId) },
          { headers: { 'X-Auth-Token': self.data.token } }
        );
      };

      this.removeStudent = function(studentId, sphereId) {
        return $http({
          method: 'DELETE',
          url: API_URL + '/manage/sphere/' + sphereId,
          data: { exam: EXAM, students_id: parseInt(studentId) },
          headers: {
            'X-Auth-Token': self.data.token,
            'Content-Type': 'application/json;charset=utf-8'
          }
        });
      };

      this.resetPasswordFromManagerAction = function(email) {
        return $http({
          method: 'POST',
          url: API_URL + '/manager_password_reset',
          data: { exam: EXAM, email: email },
          headers: {
            'X-Auth-Token': self.data.token,
            'Content-Type': 'application/json;charset=utf-8'
          }
        });
      };

      this.getClass = function(sphereId) {
        var url = API_URL + '/class?exam=' + EXAM;
        if (sphereId) {
          url += '&sphere_id=' + sphereId;
        }
        return $http
          .get(url, { headers: { 'X-Auth-Token': self.data.token } })
          .then(function(response) {
            return response.data.class;
          });
      };

      this.inspect = function(studentId) {
        return $http
          .get(API_URL + '/inspect/' + studentId + '?exam=' + EXAM, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            return response.data;
          });
      };

      this.getPlans = function() {
        return $http
          .get(API_URL + '/plans?exam=' + EXAM, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            return response.data.plans;
          });
      };

      this.createPlan = function(sphereId, begin, end) {
        return $http
          .post(
            API_URL + '/plans',
            {
              exam: EXAM,
              sphere_id: sphereId,
              begin_date: begin,
              end_date: end,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            { headers: { 'X-Auth-Token': self.data.token } }
          )
          .then(function(response) {
            return response.data.plan;
          });
      };

      this.deletePlan = function(planId) {
        return $http({
          method: 'DELETE',
          url: API_URL + '/plan/' + planId,
          data: { exam: EXAM },
          headers: {
            'X-Auth-Token': self.data.token,
            'Content-Type': 'application/json;charset=utf-8'
          }
        });
      };

      this.institution = function() {
        return $http
          .get(API_URL + '/institution?exam=' + EXAM, {
            headers: { 'X-Auth-Token': self.data.token }
          })
          .then(function(response) {
            return response.data;
          });
      };

      this.getInstitutionStudentsInfoInCSV = function(
        role: 'student' | 'manager',
        sphereId = null
      ) {
        let params = `?role=${role}&timezone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }`;

        if (sphereId) {
          params = `${params}&sphereId=${sphereId}`;
        }

        return $http
          .get(`${ENVIRONMENT.nodeUrl}students/download/infos${params}`, {
            headers: {
              'X-Auth-Token': self.data.token,
              exam: EXAM,
              role
            },
            withCredentials: false
          })
          .then(function(response) {
            return response.data;
          });
      };

      this.getInstitutionStudentInfoByProfileIdInCSV = function(
        studentProfileId
      ) {
        return $http
          .get(
            ENVIRONMENT.nodeUrl + 'students/download/infos/' + studentProfileId,
            {
              headers: {
                'X-Auth-Token': self.data.token,
                exam: EXAM
              },
              withCredentials: false
            }
          )
          .then(function(response) {
            return response.data;
          });
      };

      this.getInstitutionStudentInfoByProfileIdInCSV = function(
        studentProfileId
      ) {
        return window.open(
          ENVIRONMENT.nodeUrl +
            'students/download/infos/' +
            EXAM +
            '/' +
            self.data.token +
            '/' +
            studentProfileId +
            '?timezone=' +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
          '_blank'
        );
      };

      this.activatePromocode = function(coupon) {
        return $http
          .post(
            ENVIRONMENT.nodeUrl + 'coupons/apply',
            {
              coupon: coupon
            },
            {
              headers: {
                'X-Auth-Token': self.data.token,
                exam: EXAM
              },
              withCredentials: false
            }
          )
          .then(function(response) {
            // probably because of caching from the python backendside
            self.data.me.profile.expiration_date =
              response.data.profile.expiration_date;
            // self.me();
            return response.data;
          });
      };

      this.institutionCreateUser = function(
        first_name,
        last_name,
        email,
        type,
        account_type,
        level
      ) {
        return $http.post(
          API_URL + '/institution' + '?exam=' + EXAM,
          {
            exam: EXAM,
            first_name,
            last_name,
            email,
            type,
            account_type,
            level
          },
          { headers: { 'X-Auth-Token': self.data.token } }
        );
      };

      this.institutionDeleteUser = function(email) {
        return $http({
          method: 'DELETE',
          url: API_URL + '/institution',
          data: { exam: EXAM, email: email },
          headers: {
            'X-Auth-Token': self.data.token,
            'Content-Type': 'application/json;charset=utf-8'
          }
        });
      };

      this.extendUser = function(email: string) {
        return $http({
          method: 'POST',
          url: API_URL + '/institution/extend',
          data: { exam: EXAM, email: email },
          headers: {
            'X-Auth-Token': self.data.token,
            'Content-Type': 'application/json;charset=utf-8'
          }
        });
      };

      function prefixSupportFiles(support) {
        if (support.image)
          support.image = exam.examData.prefixAssets + support.image;
        if (support.training_audio)
          support.training_audio =
            exam.examData.prefixAssets + support.training_audio;
        if (support.exam_audio)
          support.exam_audio = exam.examData.prefixAssets + support.exam_audio;
      }

      this.getBrightAssessmentsResult = function(brightAssessmentsId) {
        return $http
          .get(
            ENVIRONMENT.nodeUrl +
              'bright/result/' +
              self.data.token +
              '/' +
              brightAssessmentsId,
            {
              headers: { 'X-Auth-Token': self.data.token },
              withCredentials: false
            }
          )
          .then(function(response) {
            console.log('response', response);
            return response;
          });
      };

      /*
    this.getCSVfromJSON = function (json, options) {
      return $http(ENVIRONMENT.nodeUrl + 'utils/json2csv', {
        method: 'POST',
        headers: {'X-Auth-Token': self.data.token},
        withCredentials: false,
        data: {
          jsonToTransform: json,
          options: options
        }
      })
      .then(function (response) {
        console.log('response', response);
        return response;
      });
    };
    */

      function makeGraphQLRequest(operationName, query, data, role) {
        return $http({
          method: 'POST',
          url: ENVIRONMENT.graphqlUrl,
          data: {
            operationName: operationName,
            query: query,
            variables: data
          },
          headers: {
            token: self.data.token,
            role: role,
            'Content-Type': 'application/json;charset=utf-8',
            exam: EXAM
          }
        }).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      }

      /**
       * GraphQL
       */

      const getPlanQuery = `query getPlanResults($examType: exam_types!, $sphereId: Int!, $planId: Int!, $startDate: timestamp!, $endDate: timestamp!) {
      profile_sphere_association(where: {sphere_id: {_eq: $sphereId}}) {
        profile {
          user {
            first_name
            last_name
            email
            results(where: {result_plan_associations: {plan_id: {_eq: $planId}}}) {
              listening_score
              reading_score
              oral_score
              writing_score
              score
              created_at
            }
            profiles(where: {exam_type: {_eq: $examType}}) {
              answers(where: {is_mock: {_eq: true}, created_at: {_gt: $startDate, _lt: $endDate}}, distinct_on: result_id) {
                created_at
                exam_type
                id
                result_id
                result {
                  listening_score
                  reading_score
                  oral_score
                  writing_score
                  score
                  created_at
                }
              }
            }
          }
        }
      }
    }
    `;

      this.getPlan = function(
        planId: number,
        sphereId: number,
        startDate: string,
        endDate: string
      ) {
        let data = {
          planId,
          sphereId,
          startDate,
          endDate,
          examType: EXAM
        };

        return makeGraphQLRequest(
          'getPlanResults',
          getPlanQuery,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.profile_sphere_association;
        });
      };

      var getAssessmentsQuery =
        'query get_bright_assessments($teacherId: Int!){\
      bright_assessments(where: {teacherId: {_eq: $teacherId} } ) {\
        teacherId\
        openedDate\
        institutionId\
        id\
        title\
        endDate\
        bright_assessments {\
          assessments_id\
          id\
          bright_assessment_id\
          profile {\
            user_id\
            user {\
              email\
              first_name\
              last_name\
              username\
            }\
            time_spent\
            training_active_time_seconds\
            objective\
            last_time_spent_update\
            is_teacher\
            is_manager\
            institution_id\
            id\
            expiration_date\
            exam_type\
            current_exam_id\
          }\
        }\
      }\
    }\
    ';

      var deleteBrightAssessmentsMutation =
        'mutation delete_bright_assessmentsById($id: Int!) {\
      delete_bright_assessments(where: {id: {_eq: $id}}) {\
        returning {\
          endDate\
          id\
          institutionId\
          openedDate\
          teacherId\
          title\
        }\
      }\
    }\
    ';

      var upsert_bright_assessmentsMutation =
        'mutation upsert_bright_assessments($assessment: bright_assessments_insert_input!) {\
      insert_bright_assessments(on_conflict: {constraint: bright_assessments_pkey, update_columns: [endDate, institutionId, openedDate, teacherId, title]}, objects: [$assessment]) {\
        returning {\
          endDate\
          id\
          institutionId\
          openedDate\
          teacherId\
          title\
          bright_assessments {\
            assessments_id\
            bright_assessment_id\
            tester_id\
          }\
        }\
      }\
    }\
    ';

      var getMyBrightAssessmentQuery =
        'query getMyBrightAssessment($testerId: Int!, $since: timestamptz!) {\
      bright_assessment(where: {bright_assessment: {openedDate: {_gt: $since}}, tester_id: {_eq: $testerId}}) {\
        assessments_id\
        bright_assessment_id\
        id\
        tester_id\
        bright_assessment {\
          openedDate\
        }\
      }\
    }\
    ';

      var addStudentToBrightAssessmentsMutation =
        'mutation insert_bright_assessment($object: bright_assessment_insert_input!) {\
      insert_bright_assessment(objects: [$object]) {\
        returning {\
          assessments_id\
          bright_assessment_id\
          id\
          tester_id\
        }\
      }\
    }';

      var removeStudentFromBrightAssessmentsMutation =
        'mutation delete_bright_assessment_mutation($id: Int!){\
      delete_bright_assessment(where: {id: {_eq: $id}}) {\
        returning {\
          assessments_id\
          bright_assessment_id\
          id\
          tester_id\
        }\
      }\
    }';

      var updateReferralByUserIdMutation =
        'mutation updateReferralByUserId($id: Int!, $referral: Int!) {\
      update_users(where: {id: {_eq: $id}}, _set: {referral: $referral}) {\
        returning {\
          id\
          referral\
        }\
      }\
    }';

      let getMyActivationsCodeQuery = `query getMyActivationsCode($profileId: Int!) {
      activation_codes(where: {activated_by: {_eq: $profileId}}) {
        activated_by
        code
      }
    }
    `;

      var getLessonsQuery = `query GetLessons($exam_type: exam_types!, $level: String, $usersId: [Int!]!) {
        lessons(where: {exam_type: {_eq: $exam_type}, level: {_eq: $level}}) {
          category {
            id
            name
          }
          id
          title
          scores(where: {user_id: {_in: $usersId}}) {
            known_date
            lesson_id
            trial_count
            value
          }
          level
        }
      }
    `;

      var deleteMyUserMutation =
        'mutation delete_usersById($userId: Int!) {\
      __typename\
      delete_users(where: {id: {_eq: $userId}}) {\
        affected_rows\
      }\
    }\
    ';

      self.getLessons = function(usersId = null, level = null) {
        if (!self.data.token) {
          return getLessonsAnonymous();
        }

        let role = 'teacher';
        if (!usersId) {
          role = 'user';
          usersId = [self.data.me.user.id];
        }

        var data = {
          usersId,
          exam_type: EXAM,
          level: level ?? self.data.me.profile.level
        };

        return makeGraphQLRequest(
          'GetLessons',
          getLessonsQuery,
          data,
          role
        ).then(function(response) {
          console.log(response.data);

          var sortLessons = _.sortBy(response.data.lessons, 'title');
          sortLessons = sortLessons
            .map(function(lesson: any) {
              if (role === 'user') {
                let score =
                  lesson.scores && lesson.scores[0] ? lesson.scores[0] : null;
                return {
                  ...lesson,
                  known: score ? !!score.known_date : false,
                  score: score ? score.value : null
                };
              } else {
                return { ...lesson };
              }
            })
            .filter(lesson => lesson.category.name !== 'empty');

          self.data.lessons = sortLessons;
          return sortLessons;
        });
      };
      self.getLessons.dataName = 'lessons';

      var getStatsQuery = `
      query GetStats($exam_type: exam_types!, $userId: Int!, $level: String) {
        lessons(where: {exam_type: {_eq: $exam_type}, level: {_eq: $level}}) {
          title
          id
          scores(where: {user_id: {_eq: $userId}}, limit: 1) {
            known_date
            value
            trial_count
          }
        }
        results(where: {user_id: {_eq: $userId}, _and: {exam: {exam_type: {_eq: $exam_type}, level: {_eq: $level}}}}, limit: 1, order_by: {created_at: desc}) {
          created_at
          score
        }
        estimated_scores(where: {user_id: {_eq: $userId}, exam_type: {_eq: $exam_type}}, order_by: {created_at: asc}) {
          created_at
          score
        }
        answers(where: {exam_type: {_eq: $exam_type}, user_id: {_eq: $userId}, question: {support: {exam: {level: {_eq: $level}}}}}) {
          created_at
          is_correct
          part
          extra_value
          feedback_score
          question {
            value
          }
        }
      }
    `;

      self.getStats = function(userId = null, level = null) {
        let role;
        if (!userId) {
          role = 'user';
          userId = self.data.me.user.id;
        } else {
          role = 'teacher';
        }

        var data = {
          userId,
          exam_type: EXAM,
          level: level ?? self.data.me.profile.level
        };

        const allParts =
          EXAM === 'delf'
            ? getSectionsByLevel(
                exam.examData.part.sections,
                data.level
              )[0].parts.map(part => part.id)
            : exam.getAllPartsId();

        return makeGraphQLRequest('GetStats', getStatsQuery, data, role).then(
          function(response) {
            let resData = response.data;
            resData.lessons = resData.lessons.filter(
              l => l.title !== 'Question sans leçon'
            );
            resData.answers = resData.answers.filter(a => {
              return allParts.includes(a.part);
            });
            const last_result = resData.results.length
              ? resData.results[resData.results.length - 1]
              : null;
            const worst_lessons = _.first(
              _.sortBy(resData.lessons, (lesson: any) =>
                lesson.scores?.length ? lesson.scores[0].value : 1000
              ),
              3
            );
            const known_lessons = _.first(
              _.filter(resData.lessons, function(lesson: any) {
                return lesson.scores.length && !!lesson.scores[0].known_date;
              }),
              3
            );

            let parts;
            if (resData.answers.length > 30) {
              let nbGoodAnswers = _.filter(resData.answers, function(
                answer: any
              ) {
                return answer.is_correct;
              });
              parts = getAverageByParts(resData.answers, data.level);
              var global = exam.estimatePercentScoreToGrid(
                nbGoodAnswers.length / resData.answers.length
              );

              if (EXAM === 'delf') {
                let partsExam = getSectionsByLevel(
                  exam.examData.part.sections,
                  data.level
                );

                let partsLevelByCategory = calculatePartsLevelsDelf(
                  parts,
                  partsExam[0].parts
                );

                global = calculateMeanOfTheObject(partsLevelByCategory);
              }
            } else {
              var global = null;
              parts = {};
            }

            response = {
              last_result: last_result,
              lessons: resData.lessons,
              worst_lessons: worst_lessons,
              known_lessons: known_lessons,
              estimated_scores: resData.estimated_scores,
              score: global,
              correctness: {
                // "listening": getAverageListening(),
                // "reading": getAverageReading(),
                parts: parts
                // "global": 0.27194860813704497
              }
            };

            console.log(global);

            self.data.stats = response;
            return response;
          }
        );
      };
      self.getStats.dataName = 'stats';

      function getAverageByParts(answers, level) {
        if (EXAM === 'delf') {
          let partsExam = getSectionsByLevel(
            exam.examData.part.sections,
            level
          );
          return getAverageByPartsDelf(answers, partsExam[0].parts);
        }

        if (!answers?.length) {
          return null;
        }

        return _.mapObject(_.groupBy(answers, 'part'), function(
          answers: any,
          part
        ) {
          var correctAnswers = _.filter(answers, function(answer: any) {
            return answer.is_correct;
          });
          return correctAnswers.length / answers.length;
        });
      }

      var getSummaryInstitutionQuery = `query SummaryInstitution($institutionId: Int!, $examType: exam_types) {
        institutions_by_pk(id: $institutionId) {
          name
          logo
          id
          credits
          credit_duration
          profiles(where: {exam_type: {_eq: $examType}}) {
            is_manager
            is_teacher
          }
          parent_institution_id
          parent_institution {
            name
            logo
            credits
            credit_duration
          }
        }
      }
    `;

      this.getInstitutionSummary = function() {
        console.log('yolo', self.data.me);
        var data = {
          institutionId: self.data.me.institution.id,
          examType: EXAM
        };
        console.log('data', data);
        return makeGraphQLRequest(
          'SummaryInstitution',
          getSummaryInstitutionQuery,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.institutions_by_pk;
        });
      };

      const update_answersValueGQL = `mutation update_answersValue($id: Int!, $value: answers_set_input!) {
      __typename
      update_answers(where: {id: {_eq: $id}}, _set: $value) {
        returning {
          id
        }
        affected_rows
      }
    }
    `;

      this.updateAnswersGQL = (id: number, value: Partial<Answers>) => {
        let data = {
          id,
          value
        };
        return makeGraphQLRequest(
          'update_answersValue',
          update_answersValueGQL,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      var getProfilesInstitutionQuery = `query getProfilesInstitutionQuery($institutionId: Int!, $isTeacher: Boolean!, $examType: exam_types) {
      institutions_by_pk(id: $institutionId) {
        name
        logo
        id
        credits
        credit_duration
        parent_institution_id
        parent_institution {
          name
          logo
          credits
          credit_duration
        }
        profiles(where: {is_teacher: {_eq: $isTeacher}, exam_type: {_eq: $examType}}) {
          is_manager
          is_teacher
          is_admin
          objective
          time_spent
          training_active_time_seconds
          last_time_spent_update
          expiration_date
          level
          id
          is_guest
          user {
            id
            first_name
            last_name
            email
          }
          estimated_scores(order_by: {created_at: desc}, limit: 1, where: {exam_type: {_eq: $examType}, type: {_eq: "automatic"}}) {
            score
          }
          manual_estimated_scores: estimated_scores(order_by: {created_at: desc}, limit: 1, where: {exam_type: {_eq: $examType}, type: {_eq: "manual"}}) {
            score
          }
        }
      }
    }
    `;

      // type: student or teacher
      this.getInstitutionProfiles = function(
        type: 'student' | 'teacher',
        userRole: 'manager' | 'teacher' = 'teacher'
      ) {
        var data = {
          institutionId: self.data.me.institution.id,
          isTeacher: !(type === 'student'),
          examType: EXAM
        };
        console.log('data', data);
        return makeGraphQLRequest(
          'getProfilesInstitutionQuery',
          getProfilesInstitutionQuery,
          data,
          'teacher'
        ).then(async function(response) {
          if (userRole === 'teacher' && EXAM === 'delf') {
            let restrictedProfiles = await self.getStudentRestrictionData();
            return {
              ...response.data.institutions_by_pk,
              profiles: response.data.institutions_by_pk.profiles.filter(
                (profile: any) => restrictedProfiles.includes(profile.id)
              )
            };
          }

          return response.data.institutions_by_pk;
        });
      };

      var getProfilesInstitutionWithSpheresQuery = `query getProfilesInstitutionWithSpheresQuery($institutionId: Int!, $isTeacher: Boolean!, $examType: exam_types) {
      institutions_by_pk(id: $institutionId) {
        name
        logo
        id
        credits
        profiles(where: {is_teacher: {_eq: $isTeacher}, exam_type: {_eq: $examType}}) {
          is_manager
          is_teacher
          objective
          time_spent
          training_active_time_seconds
          level
          last_time_spent_update
          id
          user {
            id
            first_name
            last_name
            email
          }
          profile_sphere_associations {
            sphere {
              name
              id
            }
          }
          estimated_scores(order_by: {created_at: desc}, limit: 1, where: {exam_type: {_eq: $examType}}) {
            score
          }
        }
      }
    }
    `;

      this.getInstitutionProfilesWithSpheres = function() {
        var data = {
          institutionId: self.data.me.institution.id,
          isTeacher: false,
          examType: EXAM
        };
        console.log('data', data);
        return makeGraphQLRequest(
          'getProfilesInstitutionWithSpheresQuery',
          getProfilesInstitutionWithSpheresQuery,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.institutions_by_pk;
        });
      };

      var getSpheresInformationsQuery = `query GetSpheresInformationsQuery($teacherId: Int!, $examType: exam_types, $institutionId: Int!) {
        spheres(where: {exam_type: {_eq: $examType}, _and: {
          _or: [
            {teacher_id: {_eq: $teacherId}},
            {_and:
              {
                institution_id: {_eq: $institutionId},
                is_global: {_eq: true}
              }
            }
          ]
        }}) {
          id
          name
          teacher_id
          is_global
          profile_sphere_associations {
            profile {
              id
              user {
                email
                first_name
                last_name
              }
            }
          }
          teacher {
            user {
              first_name
              last_name
              email
            }
          }
        }
      }`;

      this.getLearnerSpheresByProfileId = function() {
        var data = {
          profileId: self.data.me.profile.id
        };
        console.log('data', data);
        return makeGraphQLRequest(
          'GetSpheresFromProfileId',
          `query GetSpheresFromProfileId($profileId: Int!) {
            profile_sphere_association(where: { profile_id: { _eq: $profileId } }) {
              sphere {
                name
                is_global
                teacher_id
              }
            }
          }
          `,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data.profile_sphere_association;
        });
      };

      this.getMySpheres = function(
        userType: 'manager' | 'teacher' = 'teacher'
      ) {
        var data = {
          teacherId: self.data.me.profile.id,
          examType: EXAM,
          institutionId: self.data.me.institution.id
        };
        console.log('data', data);
        return makeGraphQLRequest(
          'GetSpheresInformationsQuery',
          getSpheresInformationsQuery,
          data,
          'teacher'
        )
          .then(function(response) {
            console.log(response.data);
            return response.data.spheres.map(s => {
              return {
                ...s,
                profile_sphere_associations: s.profile_sphere_associations.map(
                  p => p.profile
                )
              };
            });
          })
          .then(response => {
            console.log('spheres', userType, response);
            return response.filter(sphere => {
              if (userType === 'manager') {
                return sphere.is_global;
              } else {
                return (
                  (sphere.is_global && sphere.teacher_id === null) ||
                  sphere.teacher_id === self.data.me.profile.id
                );
              }
            });
          });
      };

      const getSphereSummaryQuery = `query GetSphereSummary($teacherId: Int!, $examType: exam_types, $institutionId: Int!) {
      spheres(where: {exam_type: {_eq: $examType}, _and: {
      _or: [
        {teacher_id: {_eq: $teacherId}},
        {_and: {
          institution_id: {_eq: $institutionId},
          teacher_id: {_is_null: true}
        }}
      ]}})  {
       id
      name
      teacher_id
    }
  }`;

      this.getMySpheresSummary = function() {
        let data = {
          teacherId: self.data.me.profile.id,
          examType: EXAM,
          institutionId: self.data.me.institution.id
        };
        console.log('data', data);
        return makeGraphQLRequest(
          'GetSphereSummary',
          getSphereSummaryQuery,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.spheres;
        });
      };

      const InsertSpheresMutation = `mutation InsertSpheres($spheres: [spheres_insert_input!]!) {
      __typename
      insert_spheres(objects: $spheres) {
        returning {
          exam_type
          id
          institution_id
          name
          is_global
        }
      }
    }`;

      this.getStudentRestrictionData = async () => {
        let res = await this.getMySpheres('teacher');

        let profilesId = uniq(
          flattenDeep(
            res.map(s => s.profile_sphere_associations.map(p => p.id))
          )
        );

        return profilesId;
      };

      this.createSphere = function(
        sphereName,
        isGlobalSphere = false,
        teacherId = null
      ) {
        console.log('isGlobalSphere', isGlobalSphere);
        var data = {
          spheres: [
            {
              name: sphereName,
              teacher_id: isGlobalSphere ? teacherId : self.data.me.profile.id,
              institution_id: self.data.me.institution.id,
              exam_type: EXAM,
              is_global: isGlobalSphere
            }
          ]
        };
        return makeGraphQLRequest(
          'InsertSpheres',
          InsertSpheresMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.spheres;
        });
      };

      const delete_spheresMutation = `mutation delete_spheres($id: Int!) {
      __typename
      delete_spheres(where: {id: {_eq: $id}}) {
        returning {
          id
          exam_type
          institution_id
          name
        }
      }
    }
    `;

      this.deleteSphere = function(sphereId) {
        let data = {
          id: sphereId
        };
        return makeGraphQLRequest(
          'delete_spheres',
          delete_spheresMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      const update_spheresNameMutation = `mutation update_spheresName($id: Int!, $partialSphere: spheres_set_input!) {
      __typename
      update_spheres(where: {id: {_eq: $id}}, _set: $partialSphere) {
        returning {
          name
          id
          exam_type
        }
      }
    }
    `;

      this.updateSphere = function(sphereId, partialSphere) {
        let data = {
          id: sphereId,
          partialSphere: partialSphere
        };
        return makeGraphQLRequest(
          'update_spheresName',
          update_spheresNameMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.spheres;
        });
      };

      this.getAssessments = function(teacherId, institutionId) {
        var data = {
          teacherId: self.data.me.profile.id
        };
        return makeGraphQLRequest(
          'get_bright_assessments',
          getAssessmentsQuery,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data.bright_assessments;
        });
      };

      this.getActivationsCode = function() {
        var data = {
          profileId: self.data.me.profile.id
        };
        return makeGraphQLRequest(
          'getMyActivationsCode',
          getMyActivationsCodeQuery,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data.activation_codes;
        });
      };

      this.getUserAssessments = function() {
        var since = moment
          .utc()
          .add(-3, 'hours')
          .toISOString();
        var data = {
          since: since,
          testerId: self.data.me.profile.id
        };
        return makeGraphQLRequest(
          'getMyBrightAssessment',
          getMyBrightAssessmentQuery,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data.bright_assessment;
        });
      };

      this.insertBrightAssessments = function(assessment) {
        delete assessment.bright_assessments;
        var data = {
          assessment: _.extend(assessment, {
            teacherId: self.data.me.profile.id,
            institutionId: self.data.me.institution.id
          })
        };
        return makeGraphQLRequest(
          'upsert_bright_assessments',
          upsert_bright_assessmentsMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      this.deleteMyUser = function() {
        let userId = self.data.me.user.id;
        return makeGraphQLRequest(
          'delete_usersById',
          deleteMyUserMutation,
          { userId },
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      this.updateReferralByUserId = function(referral) {
        var data = {
          id: self.data.me.user.id,
          referral: referral
        };
        return makeGraphQLRequest(
          'updateReferralByUserId',
          updateReferralByUserIdMutation,
          data,
          'user'
        ).then(function(response) {
          return response.data;
        });
      };

      let getBillsGQL = `query billsByUserIdAndExamType($userId: Int!, $examType: exam_types!) {
      __typename
      bills(where: {exam_type: {_eq: $examType}, user_id: {_eq: $userId}}) {
        date
        days
        id
      }
    }
    `;

      this.getBillingHistory = function() {
        var data = {
          userId: self.data.me.user.id,
          examType: EXAM
        };
        return makeGraphQLRequest(
          'billsByUserIdAndExamType',
          getBillsGQL,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data.bills;
        });
      };

      let geOrgBySlugGQL = `query getInstitutionBySlug($slug: String!) {
      institutions(where: {slug: {_eq: $slug}}, limit: 1) {
        logo
        name
      }
    }
    `;

      this.getOrgBySlug = function(slug: string) {
        const data = {
          slug
        };
        return makeGraphQLRequest(
          'getInstitutionBySlug',
          geOrgBySlugGQL,
          data,
          'anonymous'
        ).then(function(response) {
          return response.data?.institutions?.[0];
        });
      };

      this.deleteBrightAssessmentsById = function(bright_assessment_id) {
        var data = {
          id: bright_assessment_id
        };
        return makeGraphQLRequest(
          'delete_bright_assessmentsById',
          deleteBrightAssessmentsMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      this.addStudentToBrightAssessments = function(
        bright_assessments_id,
        studentId
      ) {
        var data = {
          object: {
            bright_assessment_id: bright_assessments_id,
            tester_id: studentId
          }
        };
        return makeGraphQLRequest(
          'insert_bright_assessment',
          addStudentToBrightAssessmentsMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      this.removeStudentFromBrightAssessments = function(id) {
        var data = {
          id: id
        };
        return makeGraphQLRequest(
          'delete_bright_assessment_mutation',
          removeStudentFromBrightAssessmentsMutation,
          data,
          'teacher'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      const insert_estimated_scoresMutationGQL = `mutation insert_estimated_scoresMutation($estimated_score: estimated_scores_insert_input!) {
      __typename
      insert_estimated_scores(objects: [$estimated_score]) {
        returning {
          created_at
          exam_type
          id
          score
          type
          user_id
        }
        affected_rows
      }
    }`;

      this.insert_estimated_scores = (score: number) => {
        let data = {
          exam_type: EXAM,
          created_at: moment.utc().toISOString(),
          // type: 'manual',
          user_id: self.data.me.user.id,
          score
        };
        return makeGraphQLRequest(
          'insert_estimated_scoresMutation',
          insert_estimated_scoresMutationGQL,
          { estimated_score: data },
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data;
        });
      };

      const estimated_scoresByUserIdQuery = `query estimated_scoresByUserId($userId: Int!, $type: String!, $exam_type: exam_types!) {
      estimated_scores(where: {user_id: {_eq: $userId}, type: {_eq: $type}, exam_type: {_eq: $exam_type}}) {
        created_at
        exam_type
        score
        type
      }
    }
    `;

      this.getMyEstimatedScores = () => {
        let data = {
          userId: self.data.me.user.id,
          exam_type: EXAM,
          type: 'manual'
        };
        return makeGraphQLRequest(
          'estimated_scoresByUserId',
          estimated_scoresByUserIdQuery,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data.estimated_scores;
        });
      };

      const getSupportTrainingForExercisesQuery = `query GetSupportTrainingForExercises($lessonId: Int!) {
      supports(where: {lesson_id: {_eq: $lessonId}}) {
        id
        instructions
      }
    }`;

      this.getExercicesFromLessonId = async (lessonId: number) => {
        console.log('getExercicesFromLessonId', lessonId);
        let data = {
          lessonId
        };
        return makeGraphQLRequest(
          'GetSupportTrainingForExercises',
          getSupportTrainingForExercisesQuery,
          data,
          'user'
        ).then(function(response) {
          console.log(response.data);
          return response.data.supports;
        });
      };
    }
  ])

  .service('pusher', [
    'API_URL',
    'api',
    'trainingUtils',
    function(API_URL, api, trainingUtils) {
      var pusher = new Pusher('17c5100d7e36013a499a', {
        cluster: 'eu',
        authEndpoint: API_URL + '/pusher/auth',
        auth: {
          headers: {
            'X-Auth-Token': api.data.token
          }
        }
      });

      this.channel = pusher.subscribe('private-' + api.data.me.user.id);
      this.done = true;
    }
  ]);
